import { Injectable, inject } from '@angular/core';
import { SauthTokenStore } from './sauth-token.store';
import { environment } from '../../../environments/environment';

@Injectable()
export class MarketplaceDelfiAuthConfig {
  private readonly tokenStore = inject(SauthTokenStore);

  readonly apiBaseUrl = environment.delfiComponentsApiBaseUrl;

  getSauthToken(): { idToken: string; svcToken: string } {
    const token = this.tokenStore.get() ?? '';
    return { idToken: token, svcToken: token };
  }
}
